<template>
  <div>
    <h3>云豆配置</h3>
    <el-form
      :inline="true"
      class="demo-form-inline"
      :loading="loading"
      size="mini"
    >
      <el-form-item label="状态">
        <el-select v-model="filter.status">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, key) in types"
            :key="key"
            :label="label"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="filter.role">
          <el-option label="全部" value=""></el-option>
          <el-option
            v-for="(label, key) in partyS"
            :key="key"
            :label="label"
            :value="key"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
        <el-button type="primary" plain size="mini" @click="addConfig()"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">{{ types[scope.row.status] }}</template>
      </el-table-column>
      <el-table-column prop="role" label="角色">
        <template slot-scope="scope">{{ partyS[scope.row.role] }}</template>
      </el-table-column>

      <el-table-column prop="amount" label="购买金额"></el-table-column>
      <el-table-column prop="lineAmount" label="划线金额"></el-table-column>
      <el-table-column prop="num" label="云豆数量"></el-table-column>

      <el-table-column prop="weight" label="权重"></el-table-column>
      <el-table-column
        prop="createTime"
        width="160px"
        label="创建时间"
      ></el-table-column>
      <el-table-column
        label="操作"
        header-align="center"
        width="80px"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handelChange(scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="limit"
        @current-change="(i) => (pageNum = i)"
        :page-count="pageNum"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="close"
      width="50%"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="ruleForm.role">
            <el-radio :label="1">甲方</el-radio>
            <el-radio :label="2">乙方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="购买金额" prop="amount">
          <el-input
            v-model="ruleForm.amount"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="划线金额" prop="lineAmount">
          <el-input
            v-model="ruleForm.lineAmount"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="云豆数量" prop="num">
          <el-input v-model.number="ruleForm.num"></el-input>
        </el-form-item>
        <el-form-item label="权重" prop="weight">
          <el-input
            v-model="ruleForm.weight"
            onkeyup="value=value.replace(/[^\d.]/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">锁定</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确 定</el-button
        >
        <el-button @click="close()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
// import newApi from "@/newApi/bean.js";

let { bean, user } = api;
export default {
  name: "beanLogs",
  data() {
    return {
      map,
      loading: true,
      types: {
        1: "开启",
        2: "锁定",
      },
      filter: {
        role: "",
        status: "",
      },
      list: [],
      total: 0,
      pageNum: 1,
      limit: 20,
      partyS: {
        1: "甲方",
        2: "乙方",
      },
      title: "新增云豆购买",
      dialogVisible: false,
      ruleForm: {
        amount: null,
        role: null,
        lineAmount: null,
        num: null,
        weight: 0,
        status: null,
      },
      rules: {
        amount: [
          { required: true, message: "请输入购买金额", trigger: "blur" },
        ],
        role: [{ required: true, message: "请选择角色", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        num: [
          { required: true, message: "请输入云豆数量", trigger: "blur" },
          { type: "number", message: "请输入正确的云豆数量" },
        ],
        // weight: [
        //   { required: false, message: "请输入权重", trigger: "blur" },
        //   { type: "number", message: "请输入正确的权重值" },
        // ],
      },
    };
  },
  watch: {
    pageNum() {
      this.fetch();
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let args = {
        pageNum: this.pageNum,
        limit: this.limit,
        role: this.filter.role,
        status: this.filter.status,
      };
      let res = await bean.getAllList(args);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
    },
    // 新增
    addConfig() {
      this.title = "新增云豆购买";
      this.dialogVisible = true;
      this.$refs.ruleForm.clearValidate();
    },
    // 修改
    handelChange(row) {
      // this.$refs.ruleForm.clearValidate();
      this.title = "修改云豆配置";
      bean.getConfig({ id: row.id }).then((res) => {
        if (res.data.code == 200) {
          this.ruleForm = res.data.data;
          this.dialogVisible = true;
        } else {
          this.close();
          this.$message.error("更新数据失败");
        }
      });
    },
    getConfig() {},
    close() {
      this.$refs.ruleForm.clearValidate();
      this.ruleForm = {};
      this.dialogVisible = false;
    },
    submitForm(formName) {
      this.ruleForm.amount = Number(this.ruleForm.amount);
      this.ruleForm.lineAmount = Number(this.ruleForm.lineAmount);
      this.ruleForm.weight = Number(this.ruleForm.weight);
      if (this.ruleForm.id) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            bean.update(this.ruleForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
                this.fetch();
                this.close();
              } else {
                this.close();
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            bean.add(this.ruleForm).then((res) => {
              if (res.data.code == 200) {
                this.$message.success("操作成功");
                this.fetch();
                this.close();
              } else {
                this.close();
              }
            });
          } else {
            return false;
          }
        });
      }
    },
  },
  mounted() {
    this.fetch(1);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/bean/beanConfig.vue